import { put, call, select } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import {
  loadApplicationById,
  signApplicationFailed,
  signApplicationSuccessful,
  verifySignature,
} from '../actions';
import { SYSTEM_MODULE } from '../../../configs/moduleNames';
import {
  addProgressLog, setProgressList, showProgressBar, stoppedProgressBar, uploadFile,
} from '../../System/actions';
import processError from '../../../utils/processError';
import sign from '../../System/sagas/sign';
import { nameBySave } from '../../../utils/utils';
import { dateFormatter } from '../../../utils/formatters';
import signFile from '../../System/sagas/signFile';

const getStop = state => {
  const {
    [SYSTEM_MODULE]: {
      stopProgressBar = false,
    },
  } = state;
  return stopProgressBar;
};

export default function* signApplication(action) {
  try {
    const {
      payload: {
        cert,
        application,
        hideBar = false,
      } = {},
    } = action;
    // let pool = {};
    if (!hideBar) {
      yield put(showProgressBar({
        title: 'Подписание заявления',
        text: 'sign.application',
      }));
    }
    yield put(addProgressLog({ log: `Загрузка документов по заявлению ID ${application.id || ''}.` }));
    const applicationResponse = yield put(loadApplicationById(application.id));
    const applicationData = yield applicationResponse;
    if (!applicationData) {
      yield put(addProgressLog({ log: 'Не найдено обращение для подписания.' }));
      throw new Error('Не найдено обращение для подписания.');
    }
    yield put(addProgressLog({ log: 'Список документов загружен.' }));
    const files = applicationData?.files?.length ? applicationData.files : [];

    let stopSigned = false;
    yield put((setProgressList({
      progressCountSuccess: 0,
      progressPercent: 0,
      progressCount: files.length + 1,
    })));
    for (let i = 0, len = files.length; i < len; i++) {
      stopSigned = yield select(getStop);
      if (stopSigned) {
        break;
      }
      if (files[i]?.collection_name === 'meta' || files[i]?.collection_name === 'meta_sig') {
        continue;
      }
      try {
        const signature = yield signFile(cert, files[i], true);
        if (!signature || typeof signature === 'string') {
          throw new Error('Заявление не подписано.');
        }
        yield put(addProgressLog({ log: `Фаил «${files[i]?.name || ''}» подписан.`, incSuccess: true }));
      } catch (e) {
        yield put(addProgressLog({ log: `<span class='red-text'>Фаил ${files[i]?.name || ''} не подписан. ${typeof e === 'string' ? e : ''}</span>`, incError: true }));
      }
      yield put((setProgressList({
        progressCountSuccess: i + 1,
        progressPercent: ((i + 1) / (files.length + 1)) * 100,
        progressCount: (files.length + 1),
      })));
    }
    if (!stopSigned) {
      yield put(addProgressLog({ log: `Подписание заявления c ID ${applicationData.id || ''}.` }));
      const jsonString = JSON.stringify(applicationData);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const signature = yield sign(cert, blob, true);
      if (!signature || typeof signature === 'string') {
        yield put(addProgressLog({ log: `<span class='red-text'>Заявление c ID ${applicationData.id || ''} не подписано.</span>`, incError: true }));
        throw new Error('Заявление не подписано.');
      }
      const name = nameBySave(`Заявление ${applicationData.id} от ${dateFormatter(applicationData.created_at)}`);
      const fileFormData = new FormData();
      fileFormData.append('model_type', 'application');
      fileFormData.append('model_id', applicationData.id);
      fileFormData.append('collection_name', 'meta');
      fileFormData.append('name', name);
      fileFormData.append('file', blob, `${nameBySave(name)}.json`);
      const fileUploadPromise = yield put(uploadFile(fileFormData));
      const fileUpload = yield fileUploadPromise;
      if (!fileUpload) {
        throw new Error(`Фаил «${name}» не сохранен`);
      }
      const signFormData = new FormData();
      signFormData.append('model_type', 'application');
      signFormData.append('model_id', applicationData.id);
      signFormData.append('collection_name', 'meta_sig');
      signFormData.append('name', name);
      signFormData.append('file', signature, nameBySave(`${name}.sig`));
      const signUploadPromise = yield put(uploadFile(signFormData));
      const signUpload = yield signUploadPromise;
      if (!signUpload) {
        throw new Error(`Фаил «${name}.sig» не сохранен`);
      }
      yield put(addProgressLog({ log: `Заявление c ID «${applicationData.id}» подписано.`, incSuccess: true }));
      yield put(addProgressLog({ log: `Проверка подписи заявления c ID ${applicationData.id || ''}.` }));
      let verifyData = null;
      try {
        const verifyResponse = yield put(verifySignature(applicationData.id));
        verifyData = yield verifyResponse;
        if (verifyData.message) {
          yield put(addProgressLog({ log: `Проверка подписи заявления c ID ${applicationData.id || ''}. ${verifyData.message}` }));
        } else {
          throw new Error('Ошибка проверки подписи.');
        }
      } catch (e) {
        yield put(addProgressLog({ log: `<span class='red-text'>Подпись заявления c ID ${applicationData.id || ''} не прошла проверку.</span>`, incError: true }));
        if (e.message) {
          yield put(addProgressLog({ log: `<span class='red-text'>Ошибка подписания: ${e.message}</span>`, incError: true }));
        }
        throw e;
      }
    }
    yield put((setProgressList({
      progressCountSuccess: files.length + 1,
      progressPercent: 100,
      progressCount: (files.length + 1),
    })));
    yield put(addProgressLog({ log: 'Подписание окончено.' }));
    yield put(stoppedProgressBar());
    if (!stopSigned) {
      yield put(addProgressLog({ log: `Подписание заявления c ID «${applicationData.id}» окончено.` }));
      yield put(signApplicationSuccessful());
      yield call(resolveActionPromise(action, {}));
    } else {
      yield put(addProgressLog({ log: 'Подписание прервано.' }));
      yield put(signApplicationFailed([]));
      yield call(rejectActionPromise(action, 'Подписание прервано.'));
    }
    return true;
  } catch (e) {
    yield put(addProgressLog({ log: 'Подписание окончено.' }));
    yield put(stoppedProgressBar());
    yield put(addProgressLog({ log: '<span class=\'red-text\'>Заявление не подписано.</span>', incError: true }));
    yield put(signApplicationFailed([]));
    yield call(rejectActionPromise(action, e));
    yield processError(e);
    return false;
  }
}
